// IE 2026 11 02 / ODOO-350449 (заказ Игоря: p205 заголовки рядків блоку «Непокрито» без червоної заливки — менше сигналів)
// Слова Игоря: «выделенные красным фоном заголовки строк по непокрытому автоплану сильно бросаются в глаза, но не несут особой информации …
// чем меньше сигналов, на которые нужно обращать внимание, тем лучше». Строки блока «⚠ Непокрито (автоплан)» несут классы строки alert-row /
// alert-uncovered и двойника cell-background-red (условное оформление строки: _DLRow.cssClasses / cf, правило cssStyle-CONDITIONS-MS-balance) —
// они заливали ВСЮ строку, в том числе заголовок (мера + колонки иерархии / атрибутов слева от дат). Теперь у ячеек заголовка строки эти классы
// снимаются (обычный фон и текст), ячейки-даты с проблемами остаются как были (фон / круг по виду ячеек); текст названия самого блока (полоса
// лэйаута row_type tab / tabrow, за которой идут строки с отбором alert = Uncovered) — бордовый, полоса остаётся.
// Выключатель fe.ux.uncoveredRowHeadersPlain (дефолт ВКЛ; ВЫКЛ — прежняя красная заливка заголовков, текст полосы обычный).
// Тесты — tests/unit/uncoveredHeaders.test.mjs
export const UNC_HEADERS_FLAG = 'fe.ux.uncoveredRowHeadersPlain'
export const UNC_TITLE_CLASS = 'unc-block-title'

// классы «непокрыто», заливающие ячейку, и их тон (двойник cell-background-<тон>)
const UNC_FILL = { 'alert-uncovered': 'red', 'alert-row': 'red' }
// классы, чья заливка остаётся (зоны запаса и прочие сигналы того же тона) — их тон защищает двойника от снятия
const KEEP_TONE = {
    'stock-critical': 'red', 'grade-bad': 'red', 'kpi-bad': 'red', 'cell-metric-critical': 'red', 'value-negative': 'red',
}

const listOf = (classes) => {
    if (!classes) return []
    if (typeof classes === 'string') return classes.split(/\s+/).filter(Boolean)
    if (Array.isArray(classes)) return classes.flatMap(c => String(c || '').split(/\s+/)).filter(Boolean)
    if (typeof classes.length === 'number') return Array.from(classes).map(String).filter(Boolean)   // DOMTokenList
    return []
}

// классы ячейки заголовка строки → какие снять: классы «непокрыто» и их двойник cell-background-<тон>, если тон не держит другой класс
export function uncHeaders_suppress(classes) {
    const set = new Set(listOf(classes))
    const drop = [], tones = new Set(), keep = new Set()
    for (const c of set) {
        if (UNC_FILL[c]) { drop.push(c); tones.add(UNC_FILL[c]) }
        else if (KEEP_TONE[c]) keep.add(KEEP_TONE[c])
    }
    if (!drop.length) return drop
    for (const tone of tones) {
        const twin = `cell-background-${tone}`
        if (set.has(twin) && !keep.has(tone)) drop.push(twin)
    }
    return drop
}

// строка отчёта — из блока непокрытого: отбор блока (_DLRow.where_block) / поле alert / мера *_uncovered
export function uncBlock_rowIs(dataItem) {
    if (!dataItem || typeof dataItem !== 'object') return false
    if (/^uncovered$/i.test(String(dataItem.alert ?? '').trim())) return true
    if (/_uncovered$/i.test(String(dataItem.measure ?? ''))) return true
    const wb = dataItem._DLRow?.where_block
    if (!Array.isArray(wb) || !wb.length) return false
    const stack = [...wb]; let guard = 0
    while (stack.length && guard++ < 500) {
        const x = stack.pop()
        if (!x || typeof x !== 'object') continue
        if (x.use === false) continue
        const rv = x.rightValue
        if (rv && typeof rv === 'object' && (/^uncovered$/i.test(String(rv.value ?? '').trim()) || /^uncovered$/i.test(String(rv.valueStr ?? '').trim()))) return true
        if (Array.isArray(x.attrs)) stack.push(...x.attrs)
    }
    return false
}

export const uncBlock_tabIs = (dataItem) => {
    const rt = dataItem?._DLRow?.row_type
    return rt === 'tab' || rt === 'tabrow'
}

// полоса лэйаута rows[i] — заголовок блока непокрытого: следующие строки до ближайшей полосы (не дальше limit) — из блока непокрытого.
// rowAt(j) → dataItem строки j (или null — строк больше нет)
export function uncBlock_titleIs(rowAt, i, limit = 60) {
    if (!uncBlock_tabIs(rowAt(i))) return false
    for (let j = i + 1; j <= i + limit; j++) {
        const di = rowAt(j)
        if (!di) return false
        if (uncBlock_tabIs(di)) return false
        if (uncBlock_rowIs(di)) return true
    }
    return false
}
